import React from "react";

/**
 * Plain (antd-free) warning strip for AI-generation results in Scoping / Profiling: lists the
 * server's warnings so a partial or failed draft is never silent (user ruling: absent is
 * acceptable, fake is not). Renders nothing when there is nothing to say.
 */
export function AiGenerationNotice({ title, messages, testId = "ai-generation-notice" }) {
  const list = (messages || []).filter(Boolean);
  if (list.length === 0) return null;
  return (
    <div role="alert" data-testid={testId} className="rounded-xl border border-[color:var(--color-warn-line)] bg-[color:var(--color-warn-bg)] px-4 py-3 text-xs text-[color:var(--color-warn-fg)]">
      {title ? <div className="font-black uppercase tracking-widest text-[10px] mb-1">{title}</div> : null}
      <ul className="list-disc pl-4 space-y-0.5">
        {list.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    </div>
  );
}

export default AiGenerationNotice;
